export const followUserMutation = /* GraphQL */ `
  mutation FollowUser($id: ID!) {
    followUser(followeeId: $id) {
      error
      success
    }
  }
`;

export const unFollowUserMutation = /* GraphQL */ `
  mutation UnFollowUser($id: ID!) {
    unfollowUser(followeeId: $id) {
      error
      success
    }
  }
`;

export const uploadProfilePicture = /* GraphQL */ `
  mutation uploadProfilePicture($uploadedData: S3ObjectInput!) {
    uploadProfilePicture(uploadedData: $uploadedData) {
      error
      success
    }
  }
`;

export const updateProfileMutation = /* GraphQL */ `
  mutation updateProfile($profile: UpdateUserInput!) {
    updateProfile(profile: $profile) {
      error
      success
    }
  }
`;

export const removeUserAccountMutation = /* GraphQL */ `
  mutation removeUserAccount {
    removeUserAccount {
      error
      success
    }
  }
`;
